import { DetailedHTMLProps, HTMLAttributes, ReactNode, useRef } from "react"

import { buildCssClassName } from "@/3514/utils"

import ThreeDotsMenu from "../menu/ThreeDotsMenu"

import "./styles.scss"

type DivProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

type Props = {
    className?: string
    withMenu?: boolean
    onMenuClick?: () => void
    showMenu?: boolean
    children: ReactNode
    readOnly?: boolean
    isRedesigned?: boolean
} & DivProps

const Card = ({
    children,
    className = "",
    withMenu,
    onMenuClick,
    showMenu = withMenu,
    readOnly = false,
    isRedesigned = false,
    ...rest
}: Props) => {
    const cardRef = useRef(null)

    return (
        <div
            className={buildCssClassName("card-box", className, {
                "show-hover": !readOnly,
                "!border-blue-300 !border-[1px]": isRedesigned
            })}
            {...rest}
            ref={cardRef}
        >
            {children}
            {withMenu && showMenu && !readOnly && (
                <div className="menu-threedots">
                    <ThreeDotsMenu onClick={onMenuClick} />
                </div>
            )}
        </div>
    )
}

export default Card
